import { useId } from "react";

import { Panel } from "../../../../core/Panel.js";
import { Text } from "../../../../core/Text.js";
import { Toggle } from "../../../../core/Toggle.js";
import type { AccountAdvancedContent, SettingToggle } from "../../accountContent.js";

/**
 * Settings → Advanced: switches that apply the moment they change, each with what it does and
 * its state in words.
 */
export function AccountAdvanced({ title, toggles }: AccountAdvancedContent) {
  return (
    <Panel title={title}>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {toggles.map((toggle) => (
          <ToggleSetting key={toggle.id} {...toggle} />
        ))}
      </div>
    </Panel>
  );
}

function ToggleSetting({
  label,
  description,
  checked,
  disabled,
  onCheckedChange,
  stateLabels,
}: SettingToggle) {
  const descriptionId = useId();
  return (
    <div className="flex flex-col gap-2">
      <Text variant="body-b1-strong" tone="primary">
        {label}
      </Text>
      <Text id={descriptionId} variant="body-b2" tone="secondary">
        {description}
      </Text>
      <div className="flex items-center gap-2">
        <Toggle
          label={label}
          aria-describedby={descriptionId}
          checked={checked}
          disabled={disabled}
          onCheckedChange={(next) => onCheckedChange(next)}
        />
        <Text variant="body-b2" tone="secondary" aria-hidden>
          {checked ? stateLabels.on : stateLabels.off}
        </Text>
      </div>
    </div>
  );
}
